module.exports = __webpack_public_path__ + "img/fire.79a7a802.svg";